import './carousel';
import './mega-menu';

(function (Drupal, $, once) {
  'use strict';

  $('input[id^="edit-sokord"]').attr(
    'placeholder',
    'Sök artiklar, ämnen, författare ...',
  );

  $('input[id^="edit-sokord"]')
    .focus(function () {
      $(this)
        .data('placeholder', $(this).attr('placeholder'))
        .attr('placeholder', '');
    })
    .blur(function () {
      $(this).attr('placeholder', $(this).data('placeholder'));
    });

  jQuery('.authorbox').click(function () {
    window.location = $(this).find('a').attr('href');
    return false;
  });

  jQuery('#mmtab_1 div:last-child').click(function () {
    window.location = $(this).find('a').attr('href');
    return false;
  });

  if ($(window).width() < 1025) {
    var stickyNavTop = $('.topmenu').offset().top;

    var stickyNav = function () {
      var scrollTop = $(window).scrollTop();

      if (scrollTop > stickyNavTop) {
        $('.topmenu').addClass('sticky-top');
        $('#main-wrapper').addClass('padding');
        $('.hero-search-area').addClass('sticky-search');
      } else {
        $('.topmenu').removeClass('sticky-top');
        $('#main-wrapper').removeClass('padding');
        $('.hero-search-area').removeClass('sticky-search');
      }
    };

    stickyNav();

    $(window).scroll(function () {
      stickyNav();
    });

    $(document).on('click', function (e) {
      $('.navbar-collapse').collapse('hide');
      e.stopPropagation();
    });
  }

  $('select').wrap("<div class='selectwrapper'></div>");

  $('#toggle-searchbtn').click(function () {
    $('.hero-search-area').slideToggle('fast', function () {});
  });

  if ($(window).width() < 1025) {
    $('#mmtab_1.mmenu-child-open .views-field.views-field-name').on(
      'click',
      function () {
        $(this).next('ul').toggle();
        return false;
      },
    );

    $(window).resize(function () {
      $('#mmtab_1.mmenu-child-open .views-field.views-field-name').on(
        'click',
        function () {
          $(this).next('ul').toggle();
          return false;
        },
      );
    });
  }

  if ($(window).width() > 1025) {
    $('.hero-search-area').css('display', 'block');
    $(window).resize(function () {
      $('.mm_fullwidth').offset({ left: 0 });
    });
  }

  if ($(window).width() > 1025) {
    $('.mmenuparent .dropdown-toggle').click(function () {
      var mm = $(this).siblings('ul.mm_fullwidth');
      if (mm.length) {
        var parent_offset_left = mm.parent().offset().left;
        mm.css('left', '-' + parent_offset_left + 'px');
        //mm.offset({left: parent_offset_left});
      }
    });
  }

  $('.alerts-wrapper .alert.alert-success')
    .delay(5000)
    .fadeOut(400, function () {
      $(this).alert('close');
    });

  $(document).on('click touchstart', function (e) {
    var clicktarget = $(e.target);
    var mmOpen = $('.navbar-collapse').hasClass('in');
    if (mmOpen) {
      var clickInSideMm = clicktarget.parents('.mmenuparent').length;
      if (!clickInSideMm && !clicktarget.hasClass('navbar-toggle')) {
        $('.navbar-toggle').click();
      }
    }
  });

  // Smooth scroll
  // Select all links with hashes
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length
          ? target
          : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate(
            {
              scrollTop: target.offset().top,
            },
            1000,
            function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(':focus')) {
                return false;
              } else {
                $target.attr('tabindex', '-1');
                $target.focus();
              }
            },
          );
        }
      }
    });

  // Add overlay to background when start searching
  var searchWindow = document.getElementById(
    'block-exposedformsolrsearchpage-1',
  );

  var searchModal = document.getElementById('search-overlay');
  var searchBox = document.getElementById('ui-id-1');

  // Get height of topmenu
  var topmenu = document.getElementsByClassName('topmenu');
  var topmenuHeight = $(topmenu).outerHeight(true);

  // Get height of hero search area
  var heroSearch = document.getElementsByClassName('hero-search-area');
  var heroHeight = $(heroSearch).outerHeight(true);

  // get height of topmenu & hero search area together
  var overlayOffset = topmenuHeight + heroHeight;

  searchWindow.addEventListener('click', function () {
    $(searchModal).addClass('modal-background');

    searchModal.style.display = 'block';
    searchWindow.style.zIndex = '39';

    // Set top position to overlay
    searchModal.style.top = overlayOffset + 'px';
  });

  searchWindow.addEventListener('keydown', function () {
    searchBox.style.zIndex = '39';
  });

  // Remove overlay on click, touch on window
  var removeOverlay = document.getElementById('edit-sokord'); // Page
  var removeOverlaySearch = document.getElementById('edit-sokord--2'); //Search

  if (window.location.pathname == '/sok') {
    window.addEventListener('click', function (event) {
      if (event.target !== removeOverlaySearch) {
        searchModal.style.display = 'none';
      }
    });

    window.addEventListener('touchstart', function (event) {
      if (event.target !== removeOverlaySearch) {
        searchModal.style.display = 'none';
      }
    });
  } else {
    window.addEventListener('click', function (event) {
      if (event.target !== removeOverlay) {
        searchModal.style.display = 'none';
      }
    });

    window.addEventListener('touchstart', function (event) {
      if (event.target !== removeOverlay) {
        searchModal.style.display = 'none';
      }
    });
  }

  $(function () {
    //Fix svg on page load
    var svg = document.getElementById('baoge-svg');

    var body_width = $('body').width();

    var b_width = 1440;
    var kompensationsfaktor = b_width / body_width;
    var b_edge_height = 103;
    // var b_mid_height = 50 * kompensationsfaktor;
    // var b_mid_x = b_width / 2;

    // var dx = (290 / 1440) * b_width;
    // var dx2 = (100 / 1440) * b_width;

    //Default svg path (desktop)
    //var path = 'm 0,103 1440,0 0,-103 C 1150,53 820,53 720,53 620,53 290,53 0,0 l 0,103 z';
    let path =
      'm 0,103 1440,0 0,-103 C 1150,30 820,30 720,30 620,30 290,30 0,0 l 0,103 z';

    if (body_width <= 767) {
      // Mobile
      path =
        'm 0,103 1440,0 0,-103 C 1150,20 820,20 720,20 620,20 290,20 0,0 l 0,103 z';
    } else if (body_width <= 1023) {
      //Tablet
      path =
        'm 0,103 1440,0 0,-103 C 1150,20 820,20 720,20 620,20 290,20 0,0 l 0,103 z';
    }

    var newPathElement = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path',
    );
    newPathElement.setAttribute('d', path);
    newPathElement.setAttribute(
      'style',
      'stroke:none; fill:url(#myLinearGradient1);',
    );
    svg.appendChild(newPathElement);

    svg.setAttribute('viewBox', '0 0 ' + b_width + ' ' + b_edge_height);
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', b_edge_height / kompensationsfaktor);
  });

  // Trial modal
  Drupal.behaviors.dropdownMenu = {
    attach: function () {
      $(once('dropdownMenu', '.snippet-expand-btn'))
        .each(function () {
          $(this).on('click', function () {
            $(this).parent().find('.snippet-trial-modal-second').toggle();

            // Toggle icon
            $(this).toggleClass('open');
          });
        });
    },
  };

  // Toggle filter box in search page in mobile
  if ($(window).width() < 768) {
    var collapseBtnFilter = document.getElementById('docTypeFilter');
    var collapseBtnSubject = document.getElementById('subjectFilter');

    if (collapseBtnFilter) {
      collapseBtnFilter.addEventListener('click', function () {
        $(this).toggleClass('open');
        $(this).siblings().find('.contentSubject').toggle('docFilterOpen');
      });
    }

    if (collapseBtnSubject) {
      collapseBtnSubject.addEventListener('click', function () {
        $(this).toggleClass('open');
        $(this).siblings().find('.contentSubject').toggle('docFilterOpen');
      });
    }
  }

  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest('video')) {
      e.preventDefault();
    }
  });

  // Accordion keyboard accessibility
  $(document).on('keydown', '[data-toggle="collapse"][role="tab"]', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.click();
    }
  });
  
// Override facet checkbox widget to hide the checkbox and add visually-hidden class for accessibility.
Drupal.behaviors.facetCheckboxOverride = {
  attach(context) {
    once('facet-checkbox-override', '.facet-item input[type="checkbox"]', context).forEach((checkbox) => {
      checkbox.style.removeProperty('display');
      checkbox.classList.add('visually-hidden');
    });
  }
};

})(Drupal, jQuery, once);
